import { render, staticRenderFns } from "./ValidationTooltip.vue?vue&type=template&id=3a228bbb&scoped=true"
import script from "./ValidationTooltip.vue?vue&type=script&lang=ts"
export * from "./ValidationTooltip.vue?vue&type=script&lang=ts"
import style0 from "./ValidationTooltip.vue?vue&type=style&index=0&id=3a228bbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a228bbb",
  null
  
)

export default component.exports